import { render, staticRenderFns } from "./WasWatched_v2.vue?vue&type=template&id=281df2a2&"
import script from "./WasWatched_v2.vue?vue&type=script&lang=js&"
export * from "./WasWatched_v2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports